package com.hyperether.goodjob.models

enum class Repeat {
    never,
    every_day,
    every_week,
    every_2_weeks,
    every_month,
    custom
}